import { BaseModel } from 'paliari-js-utils'

const attributes = {
  nome: '',
}

class Logradouro extends BaseModel {
  constructor(obj) {
    super(attributes, obj)
  }
}

export default Logradouro
